import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';

import useSavingState from './hooks/useSavingState';
import { SAVING_STATE_CONFIG } from './config';
import { SavingStateProps } from './types';

const SavingState: React.FC<SavingStateProps> = (props) => {
  const { isSaving } = props;
  const { t } = useTranslation();

  const { savingState } = useSavingState(isSaving);

  if (!savingState) {
    return null;
  }

  const { labelKey, Icon } = SAVING_STATE_CONFIG[savingState];

  return (
    <Stack gapX={6}>
      <Icon className="h-14 w-14" fillColorToken="icon-secondary" />
      <Typography className="italic" color="text-text-secondary" variant="body-short-03">
        {t(labelKey)}
      </Typography>
    </Stack>
  );
};

export default SavingState;
